import { left } from 'fp-ts/Either';

import { callbackParseDashboardResponse } from 'adapter/out/client/dashboard/callbackParseDashboardResponse';
import { httpClientFunction } from 'domain/types';
import GetDashboardClient from 'use-case/dashboard/get/getDashboardClient';
import GetDashboardCriteria from 'use-case/dashboard/get/getDashboardCriteria';

export default (httpClient: httpClientFunction, baseUrl: string): GetDashboardClient => (criteria: GetDashboardCriteria) =>
    httpClient(`${baseUrl}/dashboards/dashboards/${criteria.id}`, {})
        .then((response) => callbackParseDashboardResponse(response))
        .catch(() => left({ error: new Error(), status: 503 }));
